<template>
  <Row>
    <Col span="24">
      <Card dis-hover>
        <Row :gutter="5">
          <Col span="12">
            <Card dis-hover>
              <p slot="title">平台列表</p>
              <p slot="extra">
                <Button type="primary" size="small" @click="openAddHandle">新增平台</Button>
              </p>
              <b-table
                :columns="columns"
                :loading="tableLoading"
                :data="platList"
                :open-action="false"
                :highlight-row="true"
                @on-row-click="rowClick"
              ></b-table>
            </Card>
          </Col>
          <Col span="12">
            <Card v-show="!isAdd" dis-hover>
              <p slot="title">修改-{{currentPlat.name}}</p>
              <Form :label-width="80" :model="currentPlat" :rules="modifyRules" ref="modifyRef">
                <FormItem label="平台代码" prop="code">
                  <Input v-model="currentPlat.code" disabled />
                </FormItem>
                <FormItem label="平台名称" prop="name">
                  <Input v-model="currentPlat.name"/>
                </FormItem>
                <FormItem label="平台地址" prop="url">
                  <Input v-model="currentPlat.url"/>
                </FormItem>
                <FormItem label="平台描述">
                  <Input v-model="currentPlat.descript"/>
                </FormItem>
                <FormItem label="状态">
                  <i-switch size="large" v-model="currentPlat.booleanStatus">
                    <span slot="open">启用</span>
                    <span slot="close">禁用</span>
                  </i-switch>
                </FormItem>
                <FormItem class="form-btn-group">
                  <Button style="margin-left: 5px;" type="success" :loading="submitLoading" @click="postModifyRoleItem">确认修改</Button>
                </FormItem>
              </Form>
            </Card>
            <Card v-show="isAdd" dis-hover>
              <p slot="title">新增平台</p>
              <Form :label-width="80" :model="addForm" :rules="addRules" ref="addRef">
                <FormItem label="平台名称" prop="name">
                  <Input v-model="addForm.name"/>
                </FormItem>
                <FormItem label="平台代码" prop="code">
                  <Input v-model="addForm.code"/>
                </FormItem>
                <FormItem label="平台地址" prop="url">
                  <Input v-model="addForm.url"/>
                </FormItem>
                <FormItem label="平台描述" prop="descript">
                  <Input v-model="addForm.descript"/>
                </FormItem>
                <FormItem class="form-btn-group">
                  <Button style="margin-left: 5px;" type="success" :loading="submitLoading" @click="addItemHandler">确认</Button>
                </FormItem>
              </Form>
            </Card>
          </Col>
        </Row>
      </Card>
    </Col>
  </Row>
</template>

<script>
  import columnsMixin from './columns'
  import { modifyRules, addRules } from './rules'

  export default {
    name: 'PlatManage',
    mixins: [columnsMixin],
    data () {
      return {
        platList: [],
        roleList: [],
        isAdd: false, // 是否是新增 默认 否
        currentPlat: {
          name: null,
          code: null,
          descript: null,
          url: null,
          status: null,
          booleanStatus: false
        },
        modifyRules,
        addForm: {
          name: null,
          code: null,
          url: null,
          descript: null
        },
        addRules
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.getPlatList()
      },
      async getPlatList () {
        let { data } = await this.$http.queryPlatList()
        this.platList = data || []
      },
      openAddHandle () {
        this.isAdd = true
        // 切换到新增后重置表单
        this.$nextTick(() => this.$refs['addRef'].resetFields())
        // setTimeout(() => { this.$refs['addRef'].resetFields() }, 50)
      },
      rowClick (row, index) { // 表格单行点击事件
        this.isAdd = false
        row.booleanStatus = row.status === 'Y'
        this.currentPlat = row
      },
      async postModifyRoleItem () {
        if (!this.currentPlat.code) {
          this.$Message.warning('请先选择平台')
          return
        }
        let validate = await this.$refs['modifyRef'].validate(v => v)
        if (validate) {
          let query = {
            status: this.currentPlat.booleanStatus ? 'Y' : 'N',
            platCode: this.currentPlat.code,
            platName: this.currentPlat.name,
            url: this.currentPlat.url,
            descript: this.currentPlat.descript
          }
          this.submitLoading = true
          let { succ } = await this.$http.updatePlat(query)
          this.submitLoading = false
          if (succ) {
            this.getPlatList()
            this.$Message.success('更新平台成功!')
          }
        }
      },
      async addItemHandler () {
        let v = await this.$refs['addRef'].validate(v => v)
        if (v) {
          let args = {
            platCode: this.addForm.code,
            platName: this.addForm.name,
            descript: this.addForm.descript,
            url: this.addForm.url
          }
          this.submitLoading = true
          let { succ } = await this.$http.addPlat(args)
          this.submitLoading = false
          if (succ) {
            this.$Message.success('新增平台成功!')
            this.$refs['addRef'].resetFields()
            this.getPlatList()
          }
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import "~@/common/style/base.less";

  .checked-row {
    background: #29773d;
  }
</style>
